module.exports = __webpack_public_path__ + "assets/img/banner-4.b4440646.png";